import { MetricPayload } from "../models/metric-model";
import { getUserInfoAsync } from "../services/authenticator-service";
import { createAuthorisedApiRequest } from "./create-authorised-request";
import { fetchWrapper } from "./fetch-wrapper";

export enum SaveToMatterClickSource {
  RibbonButton = "ribbon",
  TaskpaneButton = "taskpane",
}

async function logMetric(metricName: string, extraDimensions: Record<string, string> = {}) {
  try {
    const userInfo = await getUserInfoAsync();

    const metricPayload: MetricPayload = {
      Metric: {
        Name: metricName,
        Timestamp: new Date().toISOString(), // Current UTC time
        Dimensions: {
          UserId: userInfo.UserId ?? "",
          Email: userInfo.Email ?? "",
          AccountId: userInfo.AccountId ?? "",
          ...extraDimensions,
        },
      },
    };

    const { url, requestInit } = await createAuthorisedApiRequest("AddMetricUrl", metricPayload);
    const result = await fetchWrapper(url, requestInit);

    if (result.err) {
      console.error(`Add metric call returned an error when saving ${metricName} metric: `, result.err);
    }
  } catch (error) {
    console.error(`Error occurred when saving ${metricName} metric: `, error);
  }
}

export async function logAssignToMatterClickedMetric(fileId: string, automatedDocumentId: string) {
  await logMetric("Active_Web_WordWebAddin_Assign_Clicked", {
    FileId: fileId,
    AutomatedDocumentId: automatedDocumentId,
  });
}

export async function logSaveToMatterClickedMetric(
  fileId: string,
  automatedDocumentId: string,
  source: SaveToMatterClickSource,
  recipient: string
) {
  await logMetric("Active_Web_WordWebAddin_SaveToMatter_Clicked", {
    FileId: fileId,
    AutomatedDocumentId: automatedDocumentId,
    Source: source,
    Recipient: recipient,
  });
}

export async function logEnablementMetric() {
  const name = "Active_Web_NA_WordAddin_Enabled";

  if (!localStorage.getItem(name)) {
    await logMetric(name);
    localStorage.setItem(name, "true");
  }
}
